import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Eye, Target, Calendar } from 'lucide-react';
export function SolutionSection() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-12 px-4 bg-white" data-id="element-103">
      <div className="max-w-4xl mx-auto" data-id="element-104">
        {/* Imagine the opposite */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center mb-12" data-id="element-105">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-brand-dark mb-4" data-id="element-106">
            Ahora imagina lo contrario
          </h2>
          <p className="text-lg text-gray-600 mb-4 max-w-2xl mx-auto" data-id="element-107">
            Imagina abrir tu día de trabajo y ver todo claro. Cada lead
            organizado. Cada cliente con su historial. Cada seguimiento
            programado.
          </p>

          <div className="inline-flex flex-col sm:flex-row gap-3 text-left text-sm" data-id="element-108">
            <span className="flex items-center gap-2 bg-brand-light px-4 py-2 rounded-lg" data-id="element-109">
              <Target className="text-brand-blue w-4 h-4" data-id="element-110" /> Quién está listo
              para comprar
            </span>
            <span className="flex items-center gap-2 bg-brand-light px-4 py-2 rounded-lg" data-id="element-111">
              <Calendar className="text-brand-blue w-4 h-4" data-id="element-112" /> Quién necesita
              seguimiento
            </span>
            <span className="flex items-center gap-2 bg-brand-light px-4 py-2 rounded-lg" data-id="element-113">
              <Eye className="text-brand-blue w-4 h-4" data-id="element-114" /> Quién solo está
              mirando
            </span>
          </div>

          <p className="text-xl font-bold text-brand-green mt-6" data-id="element-115">
            Tu día deja de ser caótico… y se vuelve estratégico.
          </p>
        </motion.div>

        {/* Features Checklist */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-116">
          <h3 className="text-2xl font-heading font-bold text-center text-brand-dark mb-6" data-id="element-117">
            Lo que incluye el Kit
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-118">
            {[{
            title: 'Seguimiento de leads',
            desc: 'Organiza cada contacto desde el primer mensaje.'
          }, {
            title: 'Pipeline de ventas',
            desc: 'Visualiza en qué etapa está cada cliente.'
          }, {
            title: 'Registro de propiedades',
            desc: 'Nunca más olvides qué buscaba cada persona.'
          }, {
            title: 'Agenda de seguimientos',
            desc: 'Sabes exactamente cuándo volver a escribir.'
          }, {
            title: 'Clasificación de leads',
            desc: 'Diferencia entre curiosos y compradores reales.'
          }, {
            title: 'Control de oportunidades',
            desc: 'Nada se pierde. Nada se olvida.'
          }].map((feature, idx) => <div key={idx} className="flex items-start gap-3 bg-brand-light p-4 rounded-xl" data-id="element-119">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-120" />
                <div data-id="element-121">
                  <h4 className="font-bold text-brand-dark" data-id="element-122">{feature.title}</h4>
                  <p className="text-sm text-gray-600" data-id="element-123">{feature.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="text-center mt-8" data-id="element-124">
            <p className="text-2xl font-heading font-black text-brand-dark" data-id="element-125">
              Más orden. Más control.{' '}
              <span className="text-brand-green" data-id="element-126">Más cierres.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}